var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/modal/afterpay-info/step3.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<svg class=\"i-afterpay-process-icon\" xmlns=\"http://www.w3.org/2000/svg\" aria-hidden=\"true\" x=\"0px\" y=\"0px\"\n     viewBox=\"0 0 100 100\" style=\"enable-background:new 0 0 100 100;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n    .st0{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\n</style>\n<polyline class=\"st0\" points=\"61.5,50.2 65.9,54.7 74.5,46.1 \"/>\n<circle class=\"st0\" cx=\"40\" cy=\"48\" r=\"14.5\"/>\n<circle class=\"st0\" cx=\"40\" cy=\"43.8\" r=\"6.1\"/>\n<path class=\"st0\" d=\"M29.9,58.5c1.1-3.5,4.4-5.8,8-5.8h4.2c3.6,0,6.9,2.3,8,5.8\"/>\n<line class=\"st0\" x1=\"45.5\" y1=\"74.6\" x2=\"54.5\" y2=\"74.6\"/>\n<path class=\"st0\" d=\"M19.4,23.6h61.1c2.2,0,3.9,1.8,3.9,3.9l0,0v45.1l0,0h-69l0,0V27.5C15.5,25.2,17.3,23.6,19.4,23.6L19.4,23.6z\"/>\n<path class=\"st0\" d=\"M12.5,72.6h75c1.1,0,2,0.9,2,2l0,0c0,1.1-0.9,2-2,2h-75c-1.1,0-2-0.9-2-2l0,0C10.5,73.4,11.4,72.6,12.5,72.6z\"\n    />\n</svg>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/modal/afterpay-info/step3.j2"] , dependencies)